import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DashboardService} from '../../../../services/dashboard.service';
import {AlertService} from 'ngx-alerts';
import {finalize} from 'rxjs/operators';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'app-vehicles',
  templateUrl: './vehicles.component.html',
  styleUrls: ['./vehicles.component.scss']
})
export class VehiclesComponent implements OnInit {
  breadCrumbItems: Array<{}>;
  customerName: string = '';
  customerId: any;
  vehicles: any = [];

  constructor(private router: Router, private route: ActivatedRoute, private alertService: AlertService,
              public dashboardService: DashboardService, private spinner: NgxSpinnerService) {
  }

  ngOnInit(): void {
    // this.breadCrumbItems = [{label: 'Gypsee'}, {label: 'Customers'}, {label: 'Vehicles', active: true}];
    this.route.queryParams.subscribe(
      (res: any) => {
        this.customerName = res['customerName'];
      }
    );
    this.route.params.subscribe(
      (res: any) => {
        this.customerId = res['id'];
        this.getCustomerVehicles();
      }
    );
  }


  private getCustomerVehicles() {
    this.spinner.show();
    this.dashboardService.getUserVehicles(this.customerId).pipe(finalize(() => this.spinner.hide())).subscribe(
      (res: any) => {
        this.vehicles = res.userVehicles;
      }, error1 => {
        console.error(error1);
        this.alertService.danger(error1.message ? error1.message : error1);
      }
    );
  }
}
